export enum RouteName {
  tenants = 'tenants',
}
